export default __webpack_public_path__ + "eec6e81418ffb4ac5b1e224ccf7988ea.png";